import React, { useState } from 'react'
import { View, Switch, Platform } from 'react-native'
import { useDispatch, useSelector } from 'react-redux'
import tw from 'tailwind-rn'
import { ScrollView } from 'react-native-gesture-handler'
import ActionCreators from '../../store/actions'

import * as colors from '../../config/colors'
import styles from './styles'
import { HGText, HGButton, HGGroup, HGLink } from '../HGUI'
import HGModalFull from './HGModalFull'
import ForgotPasswordForm, { ForgotPaswordValues } from './ForgotPasswordForm'
import { Markdown } from '../Content'

const isCloseToBottom = ({ layoutMeasurement, contentOffset, contentSize }) => {
  const paddingToBottom = 20
  return (
    layoutMeasurement.height + contentOffset.y >=
    contentSize.height - paddingToBottom
  )
}

type Props = {
  onSuccess: () => void
  onAbort?: () => void
  navigation: any
}

const ModalPrivacy = (props: Props) => {
  const { onSuccess, onAbort = () => {} } = props
  const dispatch = useDispatch()
  const globals = useSelector((state) => state.globals)
  const [loading, setLoading] = useState<boolean>(false)
  const [hasReadTerms, setHasReadTerms] = useState<boolean>(false)
  const [isNewsletterChecked, setIsNewsletterChecked] = useState<boolean>(false)

  if (!globals) return null
  const { privacyStatement, titlePrivacy, labelSubscribeNewsletter } = globals

  const toggleNewsletterSwitch = () =>
    setIsNewsletterChecked((previousState) => !previousState)

  const handleSubmit = async () => {
    setLoading(true)

    try {
      await dispatch(
        ActionCreators.setPrivacySettings(true, isNewsletterChecked)
      )
      onSuccess()
    } catch (reason) {
      // dispatch(
      //   ActionCreators.handleError({
      //     code: reason.code,
      //     message: reason.message,
      //   })
      // )
      onAbort()
    } finally {
      setLoading(false)
    }
  }

  return (
    <HGModalFull
      {...props}
      onRequestClose={() => {}}
      style={{ backgroundColor: colors.beige, flex: 1 }}
    >
      <HGGroup transparentMode>
        <View>
          <HGText style={tw('text-center mb-6')}>{titlePrivacy}</HGText>

          <ScrollView
            style={tw('h-80 border-2 rounded border-gray-400 px-3 mb-6')}
            onScroll={({ nativeEvent }) => {
              if (isCloseToBottom(nativeEvent)) {
                setHasReadTerms(true)
              }
            }}
            scrollEventThrottle={400}
          >
            <Markdown content={privacyStatement} />
          </ScrollView>

          <View
            style={tw(
              `mt-6 mb-6 flex flex-row ${Platform.OS !== 'ios' ? 'pl-3' : ''}`
            )}
          >
            <Switch
              trackColor={{ false: colors.gray, true: colors.blue }}
              // thumbColor={isNewsletterChecked ? '#f5dd4b' : '#f4f3f4'}
              ios_backgroundColor="#3e3e3e"
              onValueChange={toggleNewsletterSwitch}
              value={isNewsletterChecked}
              style={tw(`mr-3`)}
            />

            <HGText onPress={toggleNewsletterSwitch} style={tw('flex-1')} bold>
              {labelSubscribeNewsletter}
            </HGText>
          </View>

          <HGButton
            title={
              loading ? 'Bitte warten …' : 'Datenschutzerklärung akzeptieren'
            }
            disabled={loading}
            onPress={() => handleSubmit()}
          />

          {/* <HGLink style={tw(`text-center mt-6`)} onPress={() => onAbort()}>
            Abbrechen
          </HGLink> */}
        </View>
      </HGGroup>
    </HGModalFull>
  )
}

ModalPrivacy.defaultProps = {
  onAbort: () => {},
}

export default ModalPrivacy
